export default function isPaidAdActivatable(paidAd) {
  if (!paidAd) {
    return false
  }

  const now = new Date().valueOf()
  const baseCheck =
    paidAd.state === 'published' &&
    now < new Date(paidAd.starts_at).valueOf() &&
    now < new Date(paidAd.ends_at).valueOf()

  if (paidAd.type === 'retailer_funded') {
    return baseCheck
  }

  return (
    baseCheck &&
    paidAd.campaign_invitation.state === 'invited' &&
    paidAd.campaign_invitation.intended_amount_cents > 0
  )
}
